{
  "point": "punkt",
  "points": "punkty",
  "credits": "punkty kredytowe",
  "loyaltyCredit": "Punkt kredytowy w programie Loyalty",
  "statusPoints": "Punkty statusowe",
  "balancePoints": "Punkty do wydania",
  "edit": "Edytuj",
  "delete": "Usuń",
  "copyOf": "Kopia elementu {value}",
  "numberedCopyOf": "Kopia {index} z {value}",
  "total": "łącznie",
  "uplift": "podniesienie poziomu",
  "approveBtn.label": "OK",
  "cancelBtn.label": "Anuluj",
  "createBtn.label": "Utwórz",
  "saveBtn.label": "Zapisz",
  "searchBtn.label": "Szukaj",
  "updateBtn.label": "Aktualizacja",
  "applyBtn.label": "Zastosuj",
  "addNewPlanBtn.label": "Dodaj plan",
  "launchPlanBtn.label": "Uruchom plan",
  "toOverviewBtn.label": "Przejdź do przeglądu",
  "collapseBtn.label": "Zwiń",
  "extendBtn.label": "Szczegóły ",
  "updateAndSave.label": "Zaktualizuj i zapisz",
  "pleaseConfirmBtn.label": "Potwierdź",
  "closeBtn.label": "Zamknij",
  "resetBtn.label": "Zresetuj",
  "confirmBtn.label": "Potwierdź",
  "status.inactive": "Nieaktywny",
  "status.active": "Aktywny",
  "status.deactivated": "Dezaktywowano",
  "status.scheduled": "Zaplanowano",
  "status.expired": "Wygasłe",
  "status.readyToUse": "Gotowe do użycia",
  "status.readyToLaunch": "Gotowe do uruchomienia",
  "status.empty": "Puste",
  "status.activity.pending": "Oczekujące",
  "status.activity.confirmed": "Potwierdzone",
  "status.activity.expired": "Wygasłe",
  "status.activity.canceled": "Anulowane",
  "status.activity.removed": "Usunięte",
  "status.default": "Domyślnie",
  "action.promotion": "Promocja",
  "action.referral": "Referencja",
  "action.action": "Akcja",
  "tiers.numberOfPurchases.plural.zero": "{number} zakupów",
  "tiers.numberOfPurchases.plural.one": "{number} zakup",
  "tiers.numberOfPurchases.plural.two": "{number} zakupów",
  "tiers.numberOfPurchases.plural.few": "{number} zakupów",
  "tiers.numberOfPurchases.plural.many": "{number} zakupów",
  "tiers.numberOfPurchases.plural.other": "{number} zakupów",
  "validity.unlimited": "Bez ograniczeń",
  "validity.limitedFromEarn.value.days.plural.zero": "{number} dn.",
  "validity.limitedFromEarn.value.days.plural.one": "{number} dzień",
  "validity.limitedFromEarn.value.days.plural.two": "{number} dn.",
  "validity.limitedFromEarn.value.days.plural.few": "{number} dn.",
  "validity.limitedFromEarn.value.days.plural.many": "{number} dn.",
  "validity.limitedFromEarn.value.days.plural.other": "{number} dn.",
  "validity.limitedFromEarn.value.weeks.plural.zero": "{number} tyg.",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number} tydzień",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number} tyg.",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number} tyg.",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number} tyg.",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number} tyg.",
  "validity.limitedFromEarn.value.months.plural.zero": "{number} miesiące",
  "validity.limitedFromEarn.value.months.plural.one": "{number} miesiąc",
  "validity.limitedFromEarn.value.months.plural.two": "{number} miesiące",
  "validity.limitedFromEarn.value.months.plural.few": "{number} miesiące",
  "validity.limitedFromEarn.value.months.plural.many": "{number} miesiące",
  "validity.limitedFromEarn.value.months.plural.other": "{number} miesiące",
  "days": "Dni",
  "dayInMonth": "Dzień",
  "month": "Miesiąc",
  "months.1": "Styczeń",
  "months.2": "Luty",
  "months.3": "Marzec",
  "months.4": "Kwiecień",
  "months.5": "Maj",
  "months.6": "Czerwiec",
  "months.7": "Lipiec",
  "months.8": "Sierpień",
  "months.9": "Wrzesień",
  "months.10": "Październik",
  "months.11": "Listopad",
  "months.12": "Grudzień",
  "form.missingSettingsAlert": "Przed zapisaniem i przejściem do następnego kroku upewnij się, że wprowadzono wszystkie wymagane informacje.",
  "noResults.title": "Nie znaleziono wyników.",
  "noResults.text": "Brak pasujących wyników dla wyszukiwania „{text}”.",
  "alertContainer.editModeAlert.message": "Edytujesz kolejną wersję swojego planu lojalnościowego. Zmiany zaczną obowiązywać po uruchomieniu nowej wersji. ",
  "alertContainer.liveModeAlert.message.linkText": "Więcej informacji",
  "alertContainer.liveModeAlert.message": "Aby edytować poziomy, stałe i dodatkowe korzyści, w sekcji Zarządzanie dodatkiem Loyalty wybierz opcję Aktualizuj i uruchom, a następnie przejdź do opcji Edytuj kolejną wersję. {link}",
  "card.isRoadmap.text": "Mapa wdrożenia",
  "catalogSelector.tooManyResults.title": "Zbyt wiele wyników dla tego wyszukiwania. ",
  "catalogSelector.tooManyResults.text": "Ponów próbę, używając bardziej szczegółowych słów kluczowych, aby zawęzić wyniki.",
  "catalogSelector.errorAlert": "Coś poszło nie tak. Spróbuj ponownie",
  "catalogSelector.searchPlaceholder.byItem": "Wyszukaj konkretny produkt.",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "Wybierz konkretne marki lub kategorie, które chcesz promować.",
  "catalogSelector.checkAllItems.label": "Wybierz wszystko",
  "catalogSelector.showAllSelections.label": "Pokaż tylko wybrane pozycje.",
  "catalogSelector.cancelBtn.label": "Zamknij",
  "catalogSelector.saveBtn.label": "Zastosuj i zapisz",
  "catalogSelector.brands.plural.zero": "{number} marek",
  "catalogSelector.brands.plural.one": "{number} marka",
  "catalogSelector.brands.plural.two": "{number} marki",
  "catalogSelector.brands.plural.few": "{number} marki",
  "catalogSelector.brands.plural.many": "{number} marek",
  "catalogSelector.brands.plural.other": "{number} marek",
  "catalogSelector.category.plural.zero": "{number} kategorii",
  "catalogSelector.category.plural.one": "{number} kategoria",
  "catalogSelector.category.plural.two": "{number} kategorie",
  "catalogSelector.category.plural.few": "{number} kategorie",
  "catalogSelector.category.plural.many": "{number} kategorii",
  "catalogSelector.category.plural.other": "{number} kategorii",
  "catalogSelector.product.plural.zero": "{number} produktów",
  "catalogSelector.product.plural.one": "{number} produkt",
  "catalogSelector.product.plural.two": "{number} produkty",
  "catalogSelector.product.plural.few": "{number} produkty",
  "catalogSelector.product.plural.many": "{number} produktów",
  "catalogSelector.product.plural.other": "{number} produktów",
  "confirmNavDialog.discardChanges.text": "Pamiętaj, aby zapisać zmiany. Jeśli opuścisz tę stronę, wszelkie niezapisane zmiany zostaną utracone.",
  "confirmNavDialog.approveBtn.label": "OK",
  "confirmNavDialog.cancelBtn.label": "Anuluj",
  "actionDashboard.overviewLinkText.referral": "Przejdź do sekcji Akcje związane z poleceniami",
  "actionDashboard.editLinkText": "Edytuj program",
  "dashboardOptions.launchedAt": "Data uruchomienia programu: ",
  "dashboardOptions.currentlyShowingLabel": "Obecnie wyświetlane:",
  "dashboardOptions.viewLabel": "Widok:",
  "masterActions.join.largeText": "Dołącz do programu lojalnościowego",
  "masterActions.purchases.largeText": "Zakup",
  "status.inactive.tooltip": "Ustawienia nie zostały ukończone.",
  "status.inactive.tooltip.proomotionEnded": "Ta promocja jest niekatywna i nie można jej edytować. Możesz skopiować promocję lub utworzyć nową.",
  "status.inactive.tooltip.connectedToRewardPools": "Pula voucherów {name} ma status {status}.",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "Sprawdź daty promocji.",
  "status.readyToUse.tooltip.promotion": "Promocja jest gotowa do użycia. Możesz automatycznie wyświetlić promocję w Portfelu członka lub dołączyć ją do członków w Edytorze kampanii za pomocą tokenów programu Loyalty.",
  "status.readyToUse.tooltip.attachable": "Akcja jest gotowa do użycia i można ją dołączyć do kontaktów za pomocą edytora kampanii przy użyciu tokenów lojalnościowych.",
  "status.active.tooltip.promotion": "Ta promocja jest aktywna i dostępna dla członków.",
  "status.active.tooltip.attachable": "Ta akcja jest aktywna. Nie można zmienić jej ustawień. Aby edytować tę akcję, należy ją najpierw dezaktywować i poczekać na określoną datę wygaśnięcia. Można również skopiować akcję, edytować kopię i uruchomić kopię jako nową akcję.",
  "status.active.tooltip.event": "Ta akcja jest aktywna. Można połączyć tę akcję z korzyściami lub programem automatyzacji.",
  "status.deactivated.tooltip.promotion": "Promocja została dezaktywowana i nie jest już dostępna dla członków.",
  "status.deactivated.tooltip.attachable": "Ta akcja została przez Ciebie dezaktywowana. Aby edytować lub usunąć tę akcję, należy poczekać na określoną datę wygaśnięcia. Można również skopiować tę akcję, edytować kopię i uruchomić kopię jako nową akcję.",
  "editorTypePopup.title": "Wybierz typ edytora",
  "editorTypePopup.text": "Klienci bez wyłącznego dostępu zobaczą stronę blokującą. Możesz utworzyć niestandardową stronę HTML lub użyć jednego z naszych szablonów.",
  "editorTypePopup.options.html.text": "Utwórz niestandardową stronę w formacie HTML",
  "editorTypePopup.options.template.text": "Utwórz stronę z szablonu",
  "fileInputField.uploadBtn.label": "Prześlij",
  "fileInputField.browseBtn.label": "Przeglądaj",
  "formStepsContainer.nextStep.text": "Następny krok",
  "formStepsContainer.prevStep.text": "Poprzedni krok",
  "iconGallery.title": "Galeria ikon programu lojalnościowego",
  "iconGallery.deleteDialog.headline": "Czy na pewno chcesz usunąć tę ikonę?",
  "iconGallery.deleteDialog.content": "Po usunięciu tej ikony nie będzie ona widoczna dla członków. Upewnij się, że ta ikona nie jest powiązana z żadną akcją ani voucherem.",
  "iconGallery.uploadResult.successMessage": "Przesłano pomyślnie.",
  "iconGallery.searchInput.placeholder": "Wyszukaj ikonę po nazwie.",
  "iconGallery.fileUploader.tooltip": "<h3>Prześlij</h3><b>Wymogi przesyłanej ikony:</b></br>Plik: SVG lub PNG</br>Format: kwadrat<br>Maks. wymiary: 200x200 pikseli <br>Maks. rozmiar pliku: 100 KB</br><sub>* Zalecamy, aby tło było przezroczyste</sub>.",
  "multiLangPopup.defaultNoticeText": "Zdefiniowany język podstawowy jest domyślnym językiem wyświetlanym przez członków, jeśli nie ma odpowiednich ustawień języka.",
  "multiLangPopup.defaultTitle.currency": "Przeliczanie waluty",
  "multiLangPopup.defaultTitle.language": "Tłumaczenia językowe",
  "multiMarketSelector.multiSelectField.placeholder": "-- Wybierz rynki --",
  "multiMarketSelector.selectField.placeholder": "-- Wybierz rynek --",
  "multiPlanSelect.label": "Wybierz swój plan lojalnościowy ",
  "preLaunchPopup.conditions.plan.title": "Ustawienia planu",
  "preLaunchPopup.conditions.plan.text": "Sprawdź ustawienia planu lojalnościowego, aby upewnić się, że wszystko jest poprawnie skonfigurowane i zgodne z warunkami dla członków.",
  "preLaunchPopup.conditions.tiers.title": "Poziomy i korzyści",
  "preLaunchPopup.conditions.tiers.text": "Sprawdź, czy poziomy są prawidłowo skonfigurowane dla wszystkich członków i czy dystrybucja kontaktów na poszczególnych poziomach jest zgodna z Twoją strategią.",
  "preLaunchPopup.conditions.rewards.title": "Pule nagród",
  "preLaunchPopup.conditions.rewards.text": "Sprawdź, czy przesłano wystarczającą liczbę kodów voucherów dla wszystkich odpowiedzi oraz czy ważność wszystkich pul i voucherów została poprawnie zdefiniowana.",
  "preLaunchPopup.conditions.actions.title": "Akcje",
  "preLaunchPopup.conditions.actions.text": "Sprawdź, czy Twoje akcje obejmują wszystkie taktyki, których chcesz użyć i czy aktywowano wszystkie domyślne akcje.",
  "preLaunchPopup.title": "Czy na pewno chcesz uruchomić swój plan w programie Loyalty?",
  "preLaunchPopup.text": "Sprawdź ustawienia, aby upewnić się, że plan lojalnościowy jest gotowy do uruchomienia:",
  "timeValidityInput.radioLabel.days": "Dni",
  "timeValidityInput.radioLabel.weeks": "Tygodnie",
  "timeValidityInput.radioLabel.months": "Miesiące",
  "ctaUrl": "Adres URL CTA",
  "ctaText": "Tekst CTA",
  "message": "Wiadomość",
  "pageNotFound": "Wygląda na to, że szukana strona nie mogła zostać znaleziona.",
  "externalEventSetup.title": "Zewnętrzne zdarzenie programu Loyalty",
  "externalEventSetup.name.label": "Nazwa zdarzenia zewnętrznego",
  "externalEventSetup.description.label": "Opis",
  "externalEventSetup.description.tooltip": "Opis jest wewnętrzny i pomaga w zarządzaniu zdarzeniami dodatku Loyalty.",
  "pointsRatesFields.perDescriptor.points": "zdobyte na",
  "catalog.item.type.category.name": "Kategoria",
  "catalog.item.type.brand.name": "Marka",
  "catalog.item.type.item.name": "Produkt",
  "catalog.item.type.itemId.name": "Identyfikator pozycji",
  "exclusiveAccessOffers.options.fixedBenefit.title": "Dostęp jako stała korzyść",
  "exclusiveAccessOffers.options.additionalBenefits.title": "Dostęp jako dodatkowa korzyść",
  "exclusiveAccessOffers.options.action.title": "Dostęp jako nagroda za czynność",
  "exclusiveAccessOffers.options.redemption.title": "Dostęp za punkty",
  "exclusiveAccessOffers.options.redemptionForFree.title": "Dostęp bezpłatny",
  "accessValidityType.options.unlimited.name": "Dostęp jest ważny przez nieograniczony czas.",
  "accessValidityType.options.limitedFromEarn.name": "Dostęp jest ważny przez ograniczony czas, począwszy od momentu jego uzyskania.",
  "accessValidityType.options.fixedDate.name": "Dostęp obowiązuje przez określony czas dla wszystkich członków.",
  "accessValidityType.options.disabled.fixedBenefit.name": "Wyłącz możliwość dostępu jako stałą nagrodę.",
  "accessValidityType.options.disabled.additionalBenefit.name": "Wyłącz możliwość dostępu jako dodatkową nagrodę.",
  "accessValidityType.options.disabled.reward.name": "Wyłącz możliwość dostępu jako nagrodę za akcję.",
  "createOfModify.options.create.name": "Aktywuj ofertę",
  "createOfModify.options.create.tooltip": "Po aktywowaniu nowej oferty reguły aktywnej oferty zostają zresetowane i są dostępne dla członków wszystkich wybranych poziomów przez zdefiniowany okres obowiązywania oferty.",
  "createOfModify.options.create.tooltip2": "Po aktywowaniu nowej oferty ograniczenia aktywnej oferty zostają zresetowane i są dostępne dla członków wszystkich wybranych poziomów przez zdefiniowany okres obowiązywania oferty. ",
  "createOfModify.options.modify.name": "Edytuj aktywną ofertę",
  "createOfModify.options.modify.tooltip": "Podczas edycji aktywnej oferty zmiany nie mają wpływu na członków, którzy już skorzystali z tej oferty.",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "Ustawienia wyłączności",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "Strona blokująca",
  "exclusiveAccessFormSteps.redemptionValue.title": "Dostęp i oferty",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "Aktywacja",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "{{points_name}} do wydania",
  "activityElementPointsText.status": "Status {{points_name}}",
  "activityElementPointsText.cashback": "Program Cashback",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "Voucher do jednorazowego użycia",
  "voucherTypeText.yearly": "Voucher do wielokrotnego użycia",
  "exclusiveAccessTypeText.permanent": "Stały wyłączny dostęp",
  "exclusiveAccessTypeText.limitedTerm": "Wyłączny dostęp na ograniczony czas",
  "mainTabs.dashboard.title": "Pulpit",
  "mainTabs.actions.title": "Akcje",
  "mainTabs.rewards.title": "Nagrody",
  "mainTabs.tiers.title": "Poziomy",
  "mainTabs.loyaltyWallet.title": "Portfel dodatku Loyalty",
  "mainTabs.memberProfiles.title": "Profile członków",
  "mainTabs.externalEvents.title": "Zdarzenia zewnętrzne",
  "mainTabs.planSettings.title": "Ustawienia planu",
  "mainTabs.vouchers.title": "Vouchery",
  "mainTabs.exclusiveAccesss.title": "Wyłączny dostęp",
  "mainTabs.loyaltyManagement.title": "Loyalty — zarządzanie",
  "mainTabs.security.title": "Konfiguracje dodatku Loyalty",
  "actionTabs.purchases.title": "Zakupy",
  "actionTabs.promotions.title": "Promocje",
  "actionTabs.engagements.title": "Zaangażowanie",
  "actionTabs.events.title": "Zdarzenia",
  "actionTabs.referral.title": "Referencja",
  "actionTabs.join.title": "Dołącz do programu lojalnościowego",
  "tierTabs.tiers.title": "Poziomy",
  "tierTabs.fixedBenefits.title": "Stałe korzyści",
  "tierTabs.additionalBenefits.title": "Dodatkowe korzyści",
  "tierTabs.contactDistribution.title": "Wykres dystrybucji",
  "managementTabs.accountSettings.title": "Ustawienia konta",
  "managementTabs.languageAndCurrency.title": "Język i waluta",
  "managementTabs.planSettings.title": "Ustawienia planu",
  "managementTabs.cashbackSettings.title": "Ustawienia programu Cashback",
  "managementTabs.membershipSettings.title": "Ustawienia członkostwa",
  "managementTabs.updateAndLaunch.title": "Zaktualizuj i uruchom",
  "onboardingTabs.accountSettings.title": "Tworzenie planu",
  "onboardingTabs.activation.title": "Aktywacja",
  "customerCalcPeriod.options.1.name": "Ostatnie 30 dni",
  "customerCalcPeriod.options.2.name": "Ostatnie 60 dni",
  "customerCalcPeriod.options.3.name": "Ostatnie 90 dni",
  "customerCalcPeriod.options.6.name": "Ostatnie 6 miesięcy",
  "customerCalcPeriod.options.12.name": "Ostatnie 12 miesięcy",
  "planType.options.points.name": "Punkty i wykorzystanie",
  "planType.options.points_and_benefits.name": "Punkty i korzyści",
  "planType.options.spend.name": "Wydatki i korzyści",
  "planType.options.points.tooltip": "Plan oparty na punktach z jednym lub wieloma poziomami i możliwością wymiany punktów.",
  "planType.options.points_and_benefits.tooltip": "Plan oparty na punktach z wieloma poziomami i nagrodami bez możliwości wymiany punktów.",
  "planType.options.spend.tooltip": "Plan oparty na wydatkach z jednym lub wieloma poziomami i korzyściami bez punktów, ale z regułami opcji zwrotu gotówki. W planie opartym na wydatkach obsługiwana jest tylko jedna waluta. W przypadku obsługi większej liczby walut konieczne jest utworzenie oddzielnego planu dla każdej waluty.",
  "pointsAllocatopmDelay.options.1.name": "24 godziny",
  "pointsAllocatopmDelay.options.2.name": "48 godzin",
  "pointsAllocatopmDelay.options.3.name": "72 godzin",
  "pointsAllocatopmDelay.options.7.name": "7 dni",
  "pointsAllocatopmDelay.options.14.name": "14 dni",
  "pointsAllocatopmDelay.options.21.name": "21 dni",
  "pointsAllocatopmDelay.options.30.name": "30 dni",
  "pointsAllocatopmDelay.options.40.name": "40 dni",
  "tierCalculationType.options.endOfYear.name": " Obliczenie poziomu następuje 31 grudnia co [X lat(a)].",
  "tierCalculationType.options.endOfYear.tooltip": "Poziomy są obliczane w ustalonym terminie, co [x lat(a)]. Członkowie, którzy zostali podniesieni do wyższego poziomu, zachowują swój status poziomu przez określony czas.",
  "tierCalculationType.options.afterJoin.name": "Obliczanie poziomu odbywa się [X mies.] od dnia, w którym członek przechodzi na dany poziom.",
  "tierCalculationType.options.afterJoin.tooltip": "Data obliczenia poziomu może się różnić w zależności od postępów członka w ramach poziomów. Członkowie, którzy przeszli na wyższy poziom, zachowują swój status co najmniej przez określony czas.",
  "tierCalculationType.options.endOfYear.spend.tooltip": "Po obliczeniu poziomu punkty kredytowe programu Loyalty są resetowane, ale członkowie zachowują swój status poziomu aż do następnego obliczenia.",
  "tierCalculationType.options.noDropout.name": "Poziomy nie są obliczane. Członkowie nie muszą spełniać wymagań, aby pozostać na tym poziomie.",
  "tierCalculationType.options.noDropout.tooltip": "Punkty są zbierane tylko za podniesienie poziomu.",
  "statusPointsExpirationType.options.tierCalc.name": "Punkty statusu wygasają i są resetowane w dniu obliczenia poziomu.",
  "statusPointsExpirationType.options.tierCalc.tooltip": "Po obliczeniu punktów są one resetowane, ale członkowie zachowują swój status poziomu do następnego obliczenia.",
  "statusPointsExpirationType.options.fromEarn.name": "Punkty statusu wygasają i są resetowane co [X mies.] od daty ich zdobycia.",
  "statusPointsExpirationType.options.fromEarn.tooltip": "Podczas obliczania poziomów obliczane są tylko ważne punkty dla danego dnia. Członkowie zachowują swój status lub spadają na niższy poziom.",
  "statusPointsExpirationType.options.never.name": "Punkty statusu nigdy nie wygasają.",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "Punkty kredytowe programu Loyalty wygasają i są resetowane w dniu obliczenia poziomów.",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "Po obliczeniu punktów kredytowych programu Loyalty są one resetowane, ale członkowie zachowują swój status poziomu aż do następnego obliczenia.",
  "loyaltyCreditExpirationType.options.fromEarn.name": "Punkty kredytowe programu Loyalty wygasają i są resetowane co [X miesięcy] od daty ich przyznania.",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "Podczas obliczania poziomów obliczane są tylko ważne punkty kredytowe programu Loyalty na dany dzień. Członkowie zachowują swój status lub spadają na niższy poziom.",
  "optIn.options.invitation.name": "Wszystkie kontakty są zaproszone do dołączenia do planu lojalnościowego.",
  "optIn.options.automatic.name": "Wszystkie kontakty automatycznie stają się członkami programu lojalnościowego.",
  "historicalBalancePoints.options.keep.name": "Nagradzanie punktami na wydatki.",
  "historicalBalancePoints.options.keep.tooltip": "Ta opcja zachęca członków do wymiany punktów na nagrody.",
  "historicalBalancePoints.options.remove.name": "Bez nagradzania punktami na wydatki.",
  "historicalBalancePoints.options.remove.tooltip": "Punkty na wydatki są resetowane i użytkownicy muszą zdobyć nowe punkty, aby je wymienić.",
  "currencyIdentifierSigh.options.symbol.name": "Symbol waluty",
  "currencyIdentifierSigh.options.symbol.tooltip": "Przykład: $500",
  "currencyIdentifierSigh.options.code.name": "Kod ISO waluty",
  "currencyIdentifierSigh.options.code.tooltip": "Przykład: 500 USD",
  "currencyIdentifierSigh.options.none.name": "Bez identyfikatora",
  "formStepRewards.options.poolSettings.title": "Ustawienia puli",
  "formStepRewards.options.uploadFile.title": "Prześlij plik",
  "formStepRewards.options.redemptionValue.title": "Ustawienia oferty",
  "formStepRewards.options.validity.title": "Ważność",
  "specialTiers.redemptopmSettings.all.name": "Użyj tych samych ustawień dla wszystkich poziomów. Wartości poszczególnych poziomów są zastępowane.",
  "voucherValidityType.options.unlimited.name": "Voucher jest ważny przez nieograniczony czas.",
  "voucherValidityType.options.limitedFromEarn.name": "Voucher jest ważny przez ograniczony czas od momentu jego uzyskania przez danego członka.",
  "voucherValidityType.options.fixedDate.name": "Voucher jest ważny przez z góry określony czas dla wszystkich członków.",
  "redemptionLimit.options.noLimit.name": "Regularnie automatycznie wyświetlaj tę ofertę członkom.",
  "redemptionLimit.options.noLimit.tooltip": "Jeśli włączysz przełącznik dla poziomu, oferta wykupu zostanie wyświetlona w Portfelu dodatku Loyalty bez ograniczeń wykupu.",
  "redemptionLimit.options.limitMember.name": "Zdecyduj, ile razy każdy członek może zrealizować voucher w określonym czasie dla tej oferty.",
  "exclusiveAccessExclusivityType.options.name.fixed": "Stała wyłączność",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "Ograniczona czasowo wyłączność",
  "exclusiveAccessExclusivityType.options.name.limited": "Ograniczona wyłączność",
  "editorContentTextDefaultValues.tag": "Wyłączny dostęp",
  "editorContentTextDefaultValues.firstHeader": "<strong>Wczesne Black Friday</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>WYPRZEDAŻ</strong>",
  "editorContentTextDefaultValues.middleText": "Ekskluzywne oferty Black Friday dla naszych lojalnych członków. Nie przegap. Dołącz do planu w programie Loyalty już teraz!",
  "editorContentTextDefaultValues.actionTopText": "Nie jesteś jeszcze członkiem? Dołącz do naszego planu w programie Loyalty i zacznij zdobywać nagrody.",
  "editorContentTextDefaultValues.leftButton": "Dołącz do programu lojalnościowego",
  "editorContentTextDefaultValues.rightButton": "Innym razem",
  "editorContentTextDefaultValues.actionBottomText": "<span>Jesteś już członkiem? <u>Zaloguj się</u></span>",
  "editorContentTextDefaultValues.middleText.mobile": "Ekskluzywne oferty dla naszych lojalnych klientów. Nie przegap okazji. Dołącz do naszego planu w programie Loyalty już teraz!",
  "editorContentTextDefaultValues.actionTopText.mobile": "Nie jesteś jeszcze członkiem? Dołącz do naszego planu w programie Loyalty.",
  "accessUrlType.options.exactUrl.name": "Blokuj i oferuj wyłączny dostęp do tej strony:",
  "accessUrlType.options.startsWithUrl.name": "Blokuj i oferuj wyłączny dostęp do wszystkich stron zaczynających się od adresu URL:",
  "formStepsContainer.tierSettings.title": "Ustawienia poziomu",
  "formStepsContainer.purchaseBenefits.title": "Zakup nagrody",
  "formStepsContainer.visibility.title": "Widoczność",
  "tierDropout.options.yes.name": "Tak, ten poziom jest obliczany, a członkowie muszą spełnić wymagania, aby pozostać na tym poziomie.",
  "tierDropout.options.no.name": "Nie, nie ma scenariusza odpadnięcia z tego poziomu.",
  "fixedBenfitType.options.oneTimeVoucher.name": "Voucher jednorazowy",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "Stały roczny voucher (wymagany jest kod wielokrotnego użytku).",
  "fixedBenfitType.options.eventAction.name": "Zdarzenie",
  "fixedBenfitType.options.exclusiveAccess.name": "Wyłączny dostęp",
  "fixedBenfitType.options.custom.name": "Niestandardowy (zapewniony niezależnie przez użytkownika)",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "Woucher wielorazowego użytku (wymagany jest kod wielokrotnego użytku).",
  "tierTypeOptions.regular.name": "W oparciu o punkty",
  "tierTypeOptions.invite.name": "Tylko na zaproszenie",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "Dowiedz się więcej",
  "tierTypeOptions.invite.tooltip": "Tylko zaproszeni lub płacący członkowie mogą należeć do danego poziomu. Zarządzaj płatnościami i członkostwem po swojej stronie. Aby dodać członka do tego poziomu, użyj interfejsu API programu Loyalty lub profili członków. {learnMoreLink}.",
  "tierTypeOptions.spend.name": "Na podstawie wydatków",
  "exclusiveAccess.cardLabels.permanent": "Stałe",
  "exclusiveAccess.cardLabels.limtedTerm": "Na określony czas",
  "cards.filterBar.moreFiltersButton": "Więcej filtrów",
  "catalogSelector.selected.single": "{items} wybrano",
  "catalogSelector.selected.multiple": "{items} i {lastItems} wybrano",
  "iconGallery.uploadResult.failMessage": "Podczas przesyłania coś poszło nie tak. Upewnij się, że pliki spełniają wymagania. \n{showFileList,select,true{{failed} z {total} nie powiodło się: {failedDetails}} other{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "za każdy",
  "activityElementMultiuplyPointsText.double": "Podwójne",
  "activityElementMultiuplyPointsText.triple": "Potrójne"
}
